import React from "react";
import { SectionHeading } from "../SectionHeading";
import { SectionCta } from "../SectionCta";
import { painPoints } from "../../data/content";
export function PainPointsSection() {
  return <section className="bg-white px-5 py-16 sm:py-20" data-id="element-266" data-mp="1ble6cdtdiav6">
      <div className="mx-auto max-w-5xl" data-id="element-267" data-mp="1bnz8z51hwutz">
        <SectionHeading kicker="Does this sound familiar?" title="Have You Ever Experienced Any of These Situations?" lead="If even one sounds familiar, this clinical resource was designed with your needs in mind." data-id="element-268" data-mp="1glil9zemuxja" />
        <ol className="mt-10 grid gap-x-10 gap-y-2 md:grid-cols-2" data-id="element-269" data-mp="nyed5lk8u33a">
          {painPoints.map((p, i) => <li key={p.title} className="flex gap-4 border-b border-navy-950/10 py-5" data-id="element-270" data-mp="sxrbb2gkewl6" data-mpi={i}>
              <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-navy-950 font-display text-lg font-black text-white" data-id="element-271" data-mp="xseow6a166kz">
                {i + 1}
              </span>
              <div data-id="element-272" data-mp="29br7q3g7c43o">
                <h3 className="font-display text-[19px] font-extrabold leading-snug text-navy-950" data-id="element-273" data-mp="2r317phlr7cdo">{p.title}</h3>
                <p className="mt-2 text-[16px] leading-relaxed text-muted" data-id="element-274" data-mp="2n1phpayywp4y">{p.body}</p>
              </div>
            </li>)}
        </ol>
        <SectionCta label="I'm ready to whiten with confidence" note="Turn every one of these doubts into a clear decision" data-id="element-275" data-mp="2i0s0p1pp2151" />
      </div>
    </section>;
}